const getDefaultState = () => {
  return {
    rowsToSkipFormazione: 0,
    fetchRowsFormazione: 25,
    currentPageFormazione: 1,
    sortColumnFormazione: "id_formazione",
    sortOrderFormazione: "desc",
  };
};
const state = getDefaultState();

const getters = {
  rowsToSkipFormazione: (state) => state.rowsToSkipFormazione,
  fetchRowsFormazione: (state) => state.fetchRowsFormazione,
  currentPageFormazione: (state) => state.currentPageFormazione,
  sortColumnFormazione: (state) => state.sortColumnFormazione,
  sortOrderFormazione: (state) => state.sortOrderFormazione,
};

// const actions = {};
const mutations = {
  setFetchRowsFormazione: (state, value) => {
    state.currentPageFormazione = 1;
    state.rowsToSkipFormazione = 0;
    state.fetchRowsFormazione = value;
  },
  setCurrentPageFormazione: (state, value) => {
    state.currentPageFormazione = value;
    state.rowsToSkipFormazione = parseInt(
      (state.currentPageFormazione - 1) * state.fetchRowsFormazione
    );
  },
  setSortColumnFormazione: (state, value) => {
    state.sortColumnFormazione = value;
  },
  setSortOrderFormazione: (state, value) => {
    state.sortOrderFormazione = value;
  },
  resetFiltersFormazione: (state) => {
    Object.assign(state, getDefaultState());
  },
};

export default {
  state,
  getters,
  mutations,
};
